module.exports = __webpack_public_path__ + "app/principal/modals/modal-add-attribute-34rp3hR2.html";